// Search service - handles all search-related API calls
import api from './api';

export const searchService = {
  // Universal search function with filter support
  search: async (query, filter = 'all') => {
    const response = await api.get('/search', {
      params: {
        q: query,
        filter: filter !== 'all' ? filter : undefined
      },
    });
    return response.data;
  },

  // Global search across all categories
  globalSearch: async (query) => {
    const response = await api.get('/search', {
      params: { q: query },
    });
    return response.data;
  },

  // Search users
  searchUsers: async (query) => {
    const response = await api.get('/users/search', {
      params: { q: query },
    });
    return response.data;
  },

  // Get all users (for people discovery)
  getAllUsers: async () => {
    const response = await api.get('/users');
    return response.data;
  },
};

export default searchService;
